/**
 * Sidebar Menu Dropdown Toggle
 * Handles mobile dropdown functionality for sidebar navigation
 */

document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggle = document.querySelector('.sidebar-dropdown-toggle');
    const navList = document.querySelector('.sidebar-nav-list');

    if (dropdownToggle && navList) {
        dropdownToggle.addEventListener('click', function () {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            // Toggle aria-expanded
            this.setAttribute('aria-expanded', !isExpanded);

            // Toggle list visibility
            navList.classList.toggle('is-open');
        });

        // Close dropdown when clicking a link
        const navLinks = navList.querySelectorAll('.sidebar-nav-link');
        navLinks.forEach(link => {
            link.addEventListener('click', function () {
                dropdownToggle.setAttribute('aria-expanded', 'false');
                navList.classList.remove('is-open');
            });
        });
    }
});
